// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RotatePrompt{background:rgba(0,0,0,.6);position:absolute;width:100%;height:100%;text-align:center}.RotatePrompt .textColor{color:#fff}.RotatePrompt__content{position:absolute;box-sizing:border-box;padding:34px;width:100%;top:50%;transform:translateY(-50%)}.RotatePrompt__icon{margin-bottom:24px}.RotatePrompt__line1{margin-bottom:24px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
